  import React, { useState, useEffect } from 'react';
  import { useNavigate } from 'react-router-dom';
  import { HTTP_STATUS } from "../utils/httpStatusCodes";
  import { apiUrls } from "../utils/apiUrls";
  import { callAPI } from "../utils/apiUtils";
  //import {isAndroidPOS, offlineLogin} from '../utils/offlineAuth';

  const LoginPageUI = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [rememberMe, setRememberMe] = useState(false);
    const navigate = useNavigate();
  useEffect(() => {

    const restoreOfflineSession = () => {

      const isAndroid =
        typeof window !== 'undefined' &&
        window.AndroidPOS &&
        typeof window.AndroidPOS.isAndroidPOS === 'function' &&
        window.AndroidPOS.isAndroidPOS() === true;

      const isOffline =
        isAndroid &&
        typeof window.AndroidPOS.isOfflineMode === 'function' &&
        window.AndroidPOS.isOfflineMode() === true;

      if (!isOffline) {
        return false;
      }

      console.log('[OFFLINE_AUTH] Android offline mode detected');

      if (
        typeof window.AndroidPOS.hasOfflineSession !== 'function'
      ) {
        console.error(
          '[OFFLINE_AUTH] hasOfflineSession unavailable'
        );
        return false;
      }

      const hasSession =
        window.AndroidPOS.hasOfflineSession();

      console.log(
        '[OFFLINE_AUTH] hasOfflineSession =',
        hasSession
      );

      if (!hasSession) {
        console.log(
          '[OFFLINE_AUTH] No saved offline session'
        );
        return false;
      }

      const sessionJson =
        window.AndroidPOS.getOfflineSession();

      if (!sessionJson) {
        console.error(
          '[OFFLINE_AUTH] Empty offline session'
        );
        return false;
      }

      try {

        const session =
          JSON.parse(sessionJson);

        console.log(
          '[OFFLINE_AUTH] Restoring session',
          {
            userId: session.userId,
            restaurantId: session.restaurantId
          }
        );

        localStorage.setItem(
          'userId',
          String(session.userId)
        );

        localStorage.setItem(
          'restaurantId',
          String(session.restaurantId)
        );

        localStorage.setItem(
          'fname',
          session.fname || ''
        );

        localStorage.setItem(
          'lname',
          session.lname || ''
        );

        localStorage.setItem(
          'restaurant_name',
          session.restaurant_name || ''
        );

        localStorage.setItem(
          'staff_login_enabled',
          session.staff_login_enabled ? '1' : '0'
        );

        localStorage.setItem(
          'offline_mode',
          '1'
        );

        navigate('/dashboard');

        return true;

      } catch (error) {

        console.error(
          '[OFFLINE_AUTH] Failed to parse session',
          error
        );

        return false;
      }

    };

    // FIRST: Android offline session
    if (restoreOfflineSession()) {
      return;
    }

    // SECOND: normal online login session
    const token =
      localStorage.getItem('accessToken') ||
      sessionStorage.getItem('accessToken');

    if (token) {
      navigate('/dashboard');
      return;
    }

    // Remember-me fields
    const savedEmail =
      localStorage.getItem('remember_email') || '';

    const savedPassword =
      localStorage.getItem('remember_password') || '';

    if (savedEmail && savedPassword) {
      setEmail(savedEmail);
      setPassword(savedPassword);
      setRememberMe(true);
    }

  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('username', email);
      formData.append('password', password);

      const response = await callAPI(
        apiUrls.LOGIN,
        {},
        "POST",
        formData,
        {}
      );

      const data = response.data;

      if (
        response.status === HTTP_STATUS.OK &&
        data &&
        data.access_token &&
        data.user
      ) {
        const user = data.user;

        // Authentication tokens
        localStorage.setItem('accessToken', data.access_token);

        if (data.refresh_token) {
          localStorage.setItem('refreshToken', data.refresh_token);
        }

        // User identity
        localStorage.setItem('userId', String(user.id));

        // IMPORTANT:
        // This is the restaurant ID returned by your API.
        localStorage.setItem('restaurantId', String(user.rid));
      if (
      typeof window !== 'undefined' &&
      window.AndroidPOS &&
      typeof window.AndroidPOS.saveOfflineSession === 'function'
    ) {
      window.AndroidPOS.saveOfflineSession(
        JSON.stringify({
          userId: String(user.id),
          restaurantId: String(user.rid),
          fname: user.fname || '',
          lname: user.lname || '',
          restaurant_name: user.restaurant_name || '',
          staff_login_enabled: !!user.staff_login_enabled
        })
      );
        console.log(
      '[OFFLINE_AUTH] hasOfflineSession:',
      window.AndroidPOS.hasOfflineSession()
    );

    console.log(
      '[OFFLINE_AUTH] savedSession:',
      window.AndroidPOS.getOfflineSession()
    )

    }

        // User information
        localStorage.setItem('fname', user.fname || '');
        localStorage.setItem('lname', user.lname || '');
        localStorage.setItem('restaurant_name', user.restaurant_name || '');

        // Restaurant staff-login configuration
        localStorage.setItem(
          'staff_login_enabled',
          user.staff_login_enabled ? '1' : '0'
        );

        // This device is currently online/authenticated.
        localStorage.removeItem('offline_mode');

        // Remember login fields if requested
        if (rememberMe) {
          localStorage.setItem('remember_email', email);
          localStorage.setItem('remember_password', password);
        } else {
          localStorage.removeItem('remember_email');
          localStorage.removeItem('remember_password');
        }

        localStorage.setItem('refreshToken', data.refresh_token);
        localStorage.setItem('fname', data.user.lname);
        localStorage.setItem('lname', data.user.fname);
        localStorage.setItem('restaurant_name', data.user.restaurant_name);
        // Whether this restaurant identifies staff by PIN. Absent on an older API build, which
        // reads as off - the same default as a restaurant that simply hasn't opted in.
        localStorage.setItem('staff_login_enabled', data.user.staff_login_enabled ? '1' : '0');
        localStorage.setItem('layout_mode', data.user.layout_mode || 'grid');

        navigate('/dashboard');
      } else {
        setError(
          (data && data.message) || 'Login failed'
        );
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Network error');
    } finally {
      setLoading(false);
    }
  };

    return (
      <div className="col-12 d-flex align-items-center">
        <div className="loginForm">
          <div className="loginLogoCol">
            <div className="loginLogoCol">
                      <a href="/">
                          <svg className="text-white" width="465" viewBox="0 0 211 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.6817 23.5898V26.0276C21.5131 24.7599 23.4146 20.8879 23.4146 20.8879V16.7273C23.4146 12.8309 20.4893 9.40987 16.605 9.14578C12.0951 8.84105 8.36931 12.6481 8.81218 17.1824C9.07221 19.8477 10.8924 22.1718 13.3668 23.2038C14.8945 23.8498 16.3491 23.8864 17.6817 23.5898ZM14.5085 16.447C14.5085 15.5735 15.2195 14.8624 16.0931 14.8624C16.9666 14.8624 17.6777 15.5735 17.6777 16.447C17.6777 17.3205 16.9666 18.0316 16.0931 18.0316C15.2195 18.0316 14.5085 17.3246 14.5085 16.447Z" fill="currentColor"></path>
                          <path d="M16.0936 0.353516C7.21996 0.353516 0 7.57348 0 16.4471C0 25.3207 7.21996 32.5406 16.0936 32.5406C18.7305 32.5406 21.2129 31.8906 23.411 30.761V29.2902V26.2714V23.7686C22.2246 24.955 20.7457 25.8529 19.1002 26.3527C18.6411 26.4949 18.1616 26.5924 17.6781 26.6655C17.1581 26.7468 16.6339 26.7996 16.0936 26.7996C10.381 26.7996 5.7329 22.1515 5.7329 16.439C5.7329 10.7264 10.381 6.07829 16.0936 6.07829C21.8061 6.07829 26.4542 10.7264 26.4542 16.439C26.4542 18.1576 26.0276 19.7787 25.2841 21.2049V29.6315C29.4527 26.7184 32.1871 21.8956 32.1871 16.4349C32.1912 7.57348 24.9712 0.353516 16.0936 0.353516Z" fill="currentColor"></path>
                          <path d="M52.6805 20.6401C54.0538 19.9331 55.1183 18.9661 55.8456 17.7675C56.5729 16.573 56.9385 15.1469 56.9385 13.5298C56.9385 11.8071 56.516 10.2835 55.679 8.99958C54.842 7.71567 53.6353 6.71617 52.0873 6.02546C50.519 5.32663 48.6459 4.97314 46.521 4.97314H35.498V27.9129H42.7099V21.9524H45.4768L49.5114 27.9169H57.101L52.2864 20.8432L52.6805 20.6401ZM48.7191 15.8783C48.1056 16.4268 47.1954 16.7071 46.0172 16.7071H42.7099V10.3648H46.0172C47.1954 10.3648 48.1015 10.6451 48.7191 11.1936C49.3448 11.7543 49.6617 12.5425 49.6617 13.5339C49.6617 14.5253 49.3448 15.3135 48.7191 15.8783Z" fill="currentColor"></path>
                          <path d="M78.8744 6.38294C76.912 5.45251 74.6123 4.9812 72.0445 4.9812H60.7412V27.9209H72.0404C74.6123 27.9209 76.912 27.4496 78.8703 26.5192C80.8125 25.5969 82.3442 24.2602 83.4168 22.5496C84.4895 20.8391 85.0339 18.7873 85.0339 16.4551C85.0339 14.123 84.4895 12.0711 83.4168 10.3606C82.3442 8.64197 80.8165 7.30524 78.8744 6.38294ZM76.0912 20.8838C74.9902 21.9361 73.5153 22.4684 71.7032 22.4684H67.9571V10.4297H71.7032C73.5153 10.4297 74.9902 10.9619 76.0912 12.0102C77.1964 13.0666 77.753 14.5577 77.753 16.447C77.753 18.3363 77.1964 19.8274 76.0912 20.8838Z" fill="currentColor"></path>
                          <path d="M128.727 20.6401C130.101 19.9331 131.165 18.9661 131.892 17.7675C132.62 16.569 132.989 15.1428 132.989 13.5298C132.989 11.8112 132.567 10.2876 131.73 8.99958C130.893 7.71567 129.686 6.71617 128.138 6.02546C126.57 5.32663 124.697 4.97314 122.572 4.97314H111.545V27.9129H118.757V21.9524H121.524L125.558 27.9169H133.148L128.333 20.8432L128.727 20.6401ZM124.762 15.8783C124.148 16.4268 123.238 16.7071 122.06 16.7071H118.753V10.3648H122.06C123.238 10.3648 124.148 10.6451 124.762 11.1936C125.388 11.7543 125.709 12.5425 125.709 13.5339C125.704 14.5253 125.388 15.3135 124.762 15.8783Z" fill="currentColor"></path>
                          <path d="M88.748 10.2265H107.235V4.9812H94.3753C91.3971 4.9812 88.9512 7.30118 88.748 10.2265Z" fill="currentColor"></path>
                          <path d="M95.8131 18.767H105.845V13.7898H88.7354V22.2774C88.7354 25.3856 91.2666 27.9169 94.3748 27.9169H107.673V22.6715H95.8131V18.767Z" fill="currentColor"></path>
                          <path d="M147.125 4.9812L137.098 27.9209H144.362L145.955 23.7848H155.507L157.1 27.9209H164.499L154.475 4.9812H147.125ZM147.856 18.8076L150.733 11.3642L153.61 18.8076H147.856Z" fill="currentColor"></path>
                          <path d="M183.965 20.6401C185.338 19.9331 186.402 18.9661 187.13 17.7675C187.857 16.569 188.227 15.1428 188.227 13.5298C188.227 11.8112 187.804 10.2876 186.967 8.99958C186.13 7.71567 184.924 6.71617 183.376 6.02546C181.807 5.32663 179.934 4.97314 177.809 4.97314H166.782V27.9129H173.994V21.9524H176.761L180.796 27.9169H188.385L183.571 20.8432L183.965 20.6401ZM180.003 15.8783C179.39 16.4268 178.48 16.7071 177.301 16.7071H173.994V10.3648H177.301C178.48 10.3648 179.39 10.6451 180.003 11.1936C180.629 11.7543 180.95 12.5425 180.95 13.5339C180.946 14.5253 180.629 15.3135 180.003 15.8783Z" fill="currentColor"></path>
                          <path d="M196.84 27.9169H204.052V10.3972H211V4.9812H189.893V10.3972H196.84V27.9169Z" fill="currentColor"></path>
                          <path d="M76.3557 39.8907V40.5327H73.4629V34.686H76.2623V35.3199H74.1495V37.2498H76.112V37.8755H74.1495V39.8907H76.3557Z" fill="currentColor"></path>
                          <path d="M83.7629 34.686V40.5368H83.0844V37.8552C83.0925 37.2214 83.1087 36.6525 83.1413 36.0837L83.1087 36.0756C82.9503 36.5184 82.735 37.0629 82.5237 37.6114L81.9142 39.1919H81.2357L80.6181 37.6114C80.419 37.0588 80.1915 36.5184 80.0412 36.0756L80.0005 36.0837C80.033 36.6525 80.0574 37.2214 80.0574 37.8552V40.5368H79.3789V34.686H80.0981L81.1098 37.132C81.252 37.4814 81.4592 38.0583 81.5526 38.359H81.5851C81.6867 38.0583 81.8939 37.4814 82.0361 37.132L83.0478 34.686H83.7629Z" fill="currentColor"></path>
                          <path d="M90.2999 36.5347C90.2999 37.7455 89.6742 38.4077 88.561 38.4077H87.7687V40.5368H87.082V34.686H88.561C89.6742 34.686 90.2999 35.3564 90.2999 36.5347ZM89.6092 36.5347C89.6092 35.7424 89.2679 35.3402 88.565 35.3402H87.7727V37.7536H88.565C89.2639 37.7536 89.6092 37.3676 89.6092 36.5347Z" fill="currentColor"></path>
                          <path d="M93.1201 38.7002V36.5184C93.1201 35.3239 93.7702 34.5803 94.8591 34.5803C95.9439 34.5803 96.5899 35.3239 96.5899 36.5184V38.7002C96.5899 39.9029 95.948 40.6464 94.8591 40.6464C93.7743 40.6464 93.1201 39.9029 93.1201 38.7002ZM95.887 38.7002V36.5184C95.887 35.7058 95.5376 35.2467 94.8591 35.2467C94.1724 35.2467 93.823 35.7058 93.823 36.5184V38.7002C93.823 39.5169 94.1724 39.9801 94.8591 39.9801C95.5335 39.976 95.887 39.5169 95.887 38.7002Z" fill="currentColor"></path>
                          <path d="M105.171 34.686L103.866 40.5327H103.123L102.489 37.6602C102.371 37.1523 102.245 36.2747 102.205 35.7952H102.172C102.131 36.2706 102.005 37.1482 101.888 37.6602L101.254 40.5327H100.51L99.2061 34.686H99.9252L100.587 38.0868C100.673 38.5134 100.823 39.2975 100.864 39.6063H100.896C100.945 39.2975 101.079 38.5703 101.181 38.0177L101.823 34.7754H102.558L103.2 38.0177C103.302 38.5703 103.436 39.2975 103.484 39.6063H103.517C103.558 39.2975 103.708 38.5134 103.793 38.0868L104.464 34.686H105.171Z" fill="currentColor"></path>
                          <path d="M110.842 39.8907V40.5327H107.949V34.686H110.749V35.3199H108.636V37.2498H110.598V37.8755H108.636V39.8907H110.842Z" fill="currentColor"></path>
                          <path d="M115.145 38.3306H114.552V40.5368H113.865V34.686H115.295C116.396 34.686 117.006 35.3361 117.006 36.4575C117.006 37.4164 116.579 38.0543 115.844 38.2615L117.197 40.5327H116.421L115.145 38.3306ZM114.552 37.6886H115.287C115.966 37.6886 116.315 37.262 116.315 36.4859C116.315 35.7262 115.966 35.3321 115.295 35.3321H114.552V37.6886Z" fill="currentColor"></path>
                          <path d="M120.773 34.686V40.5368H120.086V34.686H120.773Z" fill="currentColor"></path>
                          <path d="M127.444 34.686V40.5368H126.749L125.311 37.3961C125.128 36.9776 124.86 36.3112 124.734 35.974L124.71 35.9821C124.742 36.4981 124.775 37.2782 124.775 37.778V40.5368H124.088V34.686H124.783L126.245 37.8796C126.436 38.2818 126.696 38.8994 126.83 39.2407L126.855 39.2325C126.814 38.7247 126.761 37.9039 126.761 37.3961V34.686H127.444Z" fill="currentColor"></path>
                          <path d="M130.605 38.8222V36.3925C130.605 35.2224 131.239 34.5967 132.251 34.5967C133.246 34.5967 133.872 35.2061 133.913 36.3275H133.234C133.202 35.584 132.84 35.2508 132.247 35.2508C131.646 35.2508 131.284 35.6084 131.284 36.4047V38.8263C131.284 39.6104 131.686 39.9802 132.279 39.9802C132.889 39.9802 133.291 39.6104 133.291 38.8872V38.0015H132.263V37.392H133.949V38.8872C133.941 39.9883 133.279 40.6343 132.279 40.6343C131.28 40.6262 130.605 39.9842 130.605 38.8222Z" fill="currentColor"></path>
                          <path d="M142.266 38.3306H141.673V40.5368H140.986V34.686H142.417C143.518 34.686 144.127 35.3361 144.127 36.4575C144.127 37.4164 143.7 38.0543 142.965 38.2615L144.318 40.5327H143.542L142.266 38.3306ZM141.673 37.6886H142.408C143.087 37.6886 143.436 37.262 143.436 36.4859C143.436 35.7262 143.087 35.3321 142.417 35.3321H141.673V37.6886Z" fill="currentColor"></path>
                          <path d="M150.099 39.8907V40.5327H147.206V34.686H150.005V35.3199H147.893V37.2498H149.855V37.8755H147.893V39.8907H150.099Z" fill="currentColor"></path>
                          <path d="M152.757 38.9806H153.452C153.468 39.6428 153.846 39.9841 154.423 39.9841C155.056 39.9841 155.365 39.59 155.365 39.0415C155.365 37.7901 152.85 37.7535 152.85 36.0349C152.85 35.206 153.468 34.5803 154.415 34.5803C155.373 34.5803 155.958 35.2223 155.995 36.1852H155.3C155.276 35.5433 154.935 35.2426 154.423 35.2426C153.87 35.2426 153.545 35.5595 153.545 36.043C153.545 37.2863 156.068 37.2619 156.068 39.0496C156.068 39.8866 155.491 40.6464 154.431 40.6464C153.427 40.6464 152.777 40.0004 152.757 38.9806Z" fill="currentColor"></path>
                          <path d="M161.777 35.3321H160.525V40.5368H159.831V35.3321H158.579V34.686H161.781V35.3321H161.777Z" fill="currentColor"></path>
                          <path d="M166.51 39.2649H164.816L164.507 40.5366H163.788L165.291 34.6899H166.035L167.538 40.5366H166.819L166.51 39.2649ZM166.36 38.6311L165.885 36.6524C165.791 36.2745 165.71 35.7829 165.677 35.5594H165.653C165.62 35.787 165.535 36.2786 165.446 36.6524L164.97 38.6311H166.36Z" fill="currentColor"></path>
                          <path d="M170.22 38.7653V34.686H170.923V38.7612C170.923 39.5738 171.309 39.9476 171.886 39.9476C172.471 39.9476 172.857 39.5698 172.857 38.7612V34.686H173.551V38.7612C173.551 39.9639 172.881 40.618 171.89 40.618C170.89 40.618 170.22 39.9679 170.22 38.7653Z" fill="currentColor"></path>
                          <path d="M178.044 38.3306H177.451V40.5368H176.765V34.686H178.195C179.3 34.686 179.905 35.3361 179.905 36.4575C179.905 37.4164 179.479 38.0543 178.743 38.2615L180.096 40.5327H179.32L178.044 38.3306ZM177.451 37.6886H178.187C178.865 37.6886 179.215 37.262 179.215 36.4859C179.215 35.7262 178.865 35.3321 178.195 35.3321H177.451V37.6886Z" fill="currentColor"></path>
                          <path d="M185.175 39.2649H183.481L183.172 40.5366H182.453L183.956 34.6899H184.7L186.203 40.5366H185.484L185.175 39.2649ZM185.025 38.6311L184.55 36.6524C184.456 36.2745 184.375 35.7829 184.342 35.5594H184.318C184.286 35.787 184.2 36.2786 184.111 36.6524L183.635 38.6311H185.025Z" fill="currentColor"></path>
                          <path d="M192.331 34.686V40.5368H191.636L190.198 37.3961C190.015 36.9776 189.747 36.3112 189.621 35.974L189.596 35.9821C189.629 36.4981 189.661 37.2782 189.661 37.778V40.5368H188.975V34.686H189.669L191.132 37.8796C191.323 38.2818 191.583 38.8994 191.717 39.2407L191.742 39.2325C191.701 38.7247 191.648 37.9039 191.648 37.3961V34.686H192.331Z" fill="currentColor"></path>
                          <path d="M198.384 35.3321H197.133V40.5368H196.438V35.3321H195.187V34.686H198.388V35.3321H198.384Z" fill="currentColor"></path>
                          <path d="M200.858 38.9806H201.553C201.569 39.6428 201.947 39.9841 202.524 39.9841C203.158 39.9841 203.467 39.59 203.467 39.0415C203.467 37.7901 200.952 37.7535 200.952 36.0349C200.952 35.206 201.569 34.5803 202.516 34.5803C203.475 34.5803 204.06 35.2223 204.097 36.1852H203.402C203.377 35.5433 203.036 35.2426 202.524 35.2426C201.972 35.2426 201.647 35.5595 201.647 36.043C201.647 37.2863 204.17 37.2619 204.17 39.0496C204.17 39.8866 203.593 40.6464 202.532 40.6464C201.529 40.6464 200.875 40.0004 200.858 38.9806Z" fill="currentColor"></path>
                          </svg>
                      </a>
                  </div>
          </div>
          <h4 className="lgTitle pb-4 pb-lg-4 text-center">Log in to your Account</h4>
          <form className="formStyle" onSubmit={handleSubmit}>
            {error && (
              <div className="alert alert-danger" role="alert" style={{fontSize: '0.95em'}}>
                {error}
              </div>
            )}
            <div className="row gx-2 gy-4">
              <div className="col-12">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Username/Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </div>
              <div className="col-12">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </div>
              <div className="col-12">
                <div className="row gx-2 align-items-center">
                  <div className="col">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id="rememberCheck"
                        name="rememberMe"
                        checked={rememberMe}
                        onChange={e => setRememberMe(e.target.checked)}
                      />
                      <label className="form-check-label" htmlFor="rememberCheck">Remember me</label>
                    </div>
                  </div>
                  <div className="col-auto">
                    <button type="button" className="btn btn-link p-0" style={{fontSize: 'inherit'}} tabIndex={0}>Forgot password?</button>
                  </div>
                </div>
              </div>
              <div className="col-12 text-center">
                <button type="submit" className="btn iconBtn btnPrimary my-2" disabled={loading}>
                  <span>{loading ? 'Logging in...' : 'Log In'}</span>
                  <svg width="20" height="20" className="btnIcon">
                    <use xlinkHref="./images/sprite.svg#iconNextArrow" />
                  </svg>
                </button>
              </div>
            </div>
          </form>
          {/* <div className="text-center pt-4">
            Don’t have an account? <button type="button" data-bs-toggle="modal" data-bs-target="#registerModal" className="primaryColor" style={{background: 'none', border: 'none', padding: 0}}>Sign up for free</button>
          </div> */}
        </div>
      </div>
    );
  };

  export default LoginPageUI;